import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {CountAmenityType} from "@CheckOrder/features/amenities/features/countAmenity/types/CountAmenity.type";

export default function useCountAmenityValueGetter() {
    const singleSelectedAmenities = useAppSelector((state) => (
        state?.checkOrder?.ticket.singleSelectedAmenities
    )) || {}

    const returnSelectedAmenities = useAppSelector((state) => (
        state?.checkOrder?.ticket.returnSelectedAmenities
    )) || {}

    const getSelectedAmenitiesForThisDirection = (direction: "single" | "return") => (
        direction === "single" ? singleSelectedAmenities : returnSelectedAmenities
    )

    const getCountAmenityValue = (amenity: CountAmenityType, direction: "single" | "return") => (
        getSelectedAmenitiesForThisDirection(direction)[amenity.key]?.value ?? amenity.min
    )

    return {
        getCountAmenityValue,
    }
}